import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import { TeacherBillingSummary } from '../types/billing';

class TeacherBillingService {
  async getSummary(teacherId?: string): Promise<TeacherBillingSummary> {
    const callable = httpsCallable<
      { teacherId?: string },
      TeacherBillingSummary
    >(functions, 'getTeacherBillingSummary');
    const result = await callable({ teacherId });
    return result.data;
  }

  async updateBudget(input: {
    spendingLimitEgp: number | null;
    alertThresholds: number[];
  }): Promise<void> {
    const callable = httpsCallable<typeof input, { success: boolean }>(
      functions,
      'updateTeacherBillingBudget'
    );
    await callable(input);
  }
}

export const teacherBillingService = new TeacherBillingService();
export default teacherBillingService;
